import axiosClient from '@/api/axiosClient'
import { ApiResponse } from '@/api/services/CustomerService'
import { getCurrentUser } from '@/db/indexedDB'
import { ICashflowScore } from '@/types'

const CASHFLOW_SCORE_PAGE_SIZE = 10

export const CashflowScoreService = {
  fetchCashflowScores: async (params: {
    page: number
    modelName?: string
  }): Promise<ApiResponse<ICashflowScore>> => {
    const user = await getCurrentUser()

    const requestParams: Record<string, any> = {
      page: params.page,
      limit: CASHFLOW_SCORE_PAGE_SIZE,
    }

    if (params.modelName) {
      requestParams.modelName = params.modelName.toLowerCase()
    }

    const response = await axiosClient.get(`/users/${user.id}/cashflow-scores`, {
      params: requestParams,
    })

    return response.data
  },
}
